import React from "react"
import classNames from "classnames"

import RafaelBonavitaPhoto from "images/musicians/RafaelBonavita.jpg"
import FrancoisGuerrierPhoto from "images/musicians/FrancoisGuerrier.jpg"
import HubertMittermayerNesterovskiyPhoto from "images/musicians/HubertMittermayerNesterovskiy.jpg"
import JanKrigovskyPhoto from "images/musicians/JanKrigovsky.jpg"
import AndreasOberaignerPhoto from "images/musicians/AndreasOberaigner.jpg"
import GiorgiGvantseladzePhoto from "images/musicians/GiorgiGvantseladze.jpg"
import MariyaNesterovskaPhoto from "images/musicians/MariyaNesterovska.jpg"
import NenadLecicPhoto from "images/musicians/NenadLecic.jpg"
import KarlMarkovicsPhoto from "images/musicians/KarlMarkovics.jpg"
import FelipeFreitasPhoto from "images/musicians/FelipeFreitas.jpg"

import MusicianTile from "./tile/MusicianTile"
import { SECTION_NAMES } from "common/sectionNames"

import styles from "./MusiciansSection.module.scss"
import commonStyles from "../../common/commonStyles.module.scss"

const musicians = [
  {
    name: "Rafael Bonavita",
    photo: RafaelBonavitaPhoto,
    info: `Rafael Bonavita, Gitarren (URY) – Geboren in Montevideo. Studium der klassischen Gitarre bei Alvaro Pierri und Antiker 
    Lauten und Gitarren bei Hopkinson Smith. Weltweite Konzerttätigkeit u.a. mit Jordi Savall, 
    René Jacobs und Marc Minkovski. Zahlreiche Aufnahmen für Radio und Fernsehen in Europa und Asien. 
    CD-Einspielungen für das Label Enchiriadis mit Musik von Bach, Bartolotti, de Murcia und 
    Sanz sowie Eigenkompositionen.`,
  },
  {
    name: "Felipe Freitas",
    photo: FelipeFreitasPhoto,
    info: `Felipe Freitas, Horn (BRA) – Geboren in Rio de Janeiro, Studium ebendort bei Philip Doyle sowie in Karlsruhe 
    bei Will Sanders. Preisträger der internationalen Wettbewerbe von Prag, Markneukirchen und Porcia. 
    Seit 2023 Solohornist des Rotterdams Philharmonisch Orkest. Weltweite Konzerttätigkeit. Gründer der Plattform 
    Trompa Brasilis zur Förderung brasilianischer HornistInnen.`,
  },
  {
    name: "François Guerrier",
    photo: FrancoisGuerrierPhoto,
    info: `François Guerrier, Cembalo/Orgel (F) – Geboren in Caen. Studium am Conservatoire Superieur de Paris bei Pierre Hantaï, 
    Elisabeth Joyé, Christophe Rousset und Kenneth Weiss. Preisträger des Internationalen Bach-Wettbewerbes, 
    Leipzig 2006. Konzertreisen als Solist und Kammermusiker in Europa, Amerika und Asien mit Partnern wie 
    Stéphanie-Marie Degand, Ricercar Consort und Il Gardellino. CD-Einspielungen mit Werken von Couperin, 
    Mazzocchi und Bach.
    `,
  },
  {
    name: "Giorgi Gvantseladze",
    photo: GiorgiGvantseladzePhoto,
    info: `Giorgi Gvantseladze, Oboe (GE) – Geboren in Tiflis, Studium ebendort bei Giorgi Beridze sowie in 
    München und Salzburg bei François Leleux und Stefan Schilli. Früher Solooboist des Georgischen Nationalen 
    Symphonieorchesters sowie des Frankfurter Opern- und Museumsorchesters, seit 2010 an gleicher Position 
    an der Bayerischen Staatsoper. Als Solist, Orchester- und Kammermusiker weltweite Konzerttätigkeit, 
    u.a.m. Berliner Philharmonikern u.d. Chamber Orchestra of Europe. 
    `,
  },
  {
    name: "Ján Krigovský",
    photo: JanKrigovskyPhoto,
    info: `Ján Krigovský, Violone/Kontrabass (SVK) – Geboren in Spisska.
        Kontrabassstudium in Košice und Bratislava bei T. Trn und R. Šašina.
        Gustav Mahler Jugendorchester und Solobass im staatlichen Kammerorchester Žilina.
        Studium der Violone an der Schola Cantorum Basiliensis bei David Sinclair.
        Regelmäßiger Gast und Solist bei Wiener Akademie, Capella Istropolitana und Freitagsakademie Bern.
        Professor am Konservatorium Bratislava. Mitglied der Ars Antiqua Austria.`,
  },
  {
    name: "Nenad Lecic",
    photo: NenadLecicPhoto,
    info: `Nenad Lecic, Klavier (SRB) – Geboren in Čačak. Studium in Belgrad und Köln bei Igor Lasko, Arbo Valdma und 
    Pierre-Laurent Aimard. Debüt mit Orchester mit 11 Jahren. Young-European-Talent der RAI. 
    Preisträger zahlreicher internationaler Wettbewerbe. Konzerte in ganz Europa im Rahmen 
    renommierter Konzertreihen wie Klavierfestival Ruhr, Pianorama (WDR), Atelier (Kölner Philharmonie). 
    Dozent der Musikhochschule Köln.`,
  },
  {
    name: "Karl Markovics",
    photo: KarlMarkovicsPhoto,
    info: `Karl Markovics, Sprecher (A) – geboren in Wien, eine der facettenreichsten Personen der deutschsprachigen 
    Film- und Theaterwelt. Schauspieler auf den großen und kleinen Bühnen, sowie in erfolgreichen internationalen TV- und Kinoproduktionen, wie dem 
    Oscar-Prämierten Film »Die Fälscher«. Regisseur von beachteten Theater- und Operproduktionen sowie aufsehenerregenden Filme wie »Atmen«. 
    Vielfältige Projekte, die Sprache und Musik miteinander verbinden. `,
  },
  {
    name: "Mariya Nesterovska",
    photo: MariyaNesterovskaPhoto,
    info: `Mariya Nesterovska, Violine und Leitung (UA) – Geboren in Kiew. Studium in Kiew, Hamburg, Köln und Gent u.a. bei Ludmilla Ovcharenko und 
    Mikhail Bezverkhny. Als Solistin und Kammermusikerin bereits in jungen Jahren vielfache Preisträgerin 
    internationaler Wettbewerbe u.a. in Paris, Belgrad, Covilha, Atri, Ragusa / New York. Konzerte in 
    ganz Europa. CDs mit Werken von Skoryk, Schnittke, Franck, Telemann und Kantscheli.`,
  },
  {
    name: "Hubert Mittermayer Nesterovskiy",
    photo: HubertMittermayerNesterovskiyPhoto,
    info: `Hubert Mittermayer Nesterovskiy, Fagott und Leitung (A) – Geboren in Innsbruck. Studium bei G. Klütsch (Weimar / Köln). 
    Solofagott in Orchestern in San Sebastian, 
    Rotterdam, Köln, Turin, Mahler Chamber Orchestra u. Ensemble Modern mit Dirigenten wie Sir C. Davis, 
    L. Maazel, P. Järvi, Chr. Eschenbach und P. Boulez. Solist mit Orquesta Filarmónica de Buenos Aires 
    und Capella Istropolitana. Festivals Luzern, Ludwigsburg und Schleswig-Holstein.`,
    useCondensedFont: true,
  },
  {
    name: "Andreas Oberaigner",
    photo: AndreasOberaignerPhoto,
    info: `Andreas Oberaigner, Klarinette (A) –  Geboren in Hall in Tirol, Studium in Wien und Hannover bei Horst Hajek und Johannes
Peitz. Konzerte in Europa und Asien u.a. mit Staatskapelle Dresden, Wiener Philharmoniker, Oper Frankfurt. Erste Preise bei
nationalen Wettbewerben als Kammermusiker und Solist. Ab 2006 Stv. Soloklarinette der Duisburger Philharmoniker, seit
2024 an gleicher Position beim Gürzenichorchester Köln.`,
  },
]

export default ({ onRef }) => (
  <div
    id={SECTION_NAMES.ARTISTS}
    ref={onRef}
    className={classNames(commonStyles.sectionWrapper, styles.sectionWrapper)}
  >
    <h2 className={classNames(commonStyles.title)}>
      Auf der B&uuml;hne starke Pers&ouml;nlichkeiten
    </h2>
    <div className={styles.musicians}>
      {musicians.map((musician, i) => (
        <MusicianTile
          key={`musician-${i}`}
          {...musician}
          style={{ zIndex: musicians.length - i }}
        />
      ))}
    </div>
  </div>
)
